import {RequestAxios} from "../../index";

export const getGalleryImage = async (hrefPhoto: string) => {
    const galleryUrl = `https://static.bitafit.com/gallery${hrefPhoto}`;
    return await RequestAxios.get<any>(galleryUrl, { responseType: "blob" })
}